import config, { formaturl } from '../config/staticData';
import { Link } from 'react-router-dom';

function getImageSrc(viewType, blogPic) {
    switch (viewType) {
        case 1:
            return `${config.blogPath}${blogPic}`;
        case 8:
            return `${config.videoPath}${blogPic}`;
        case 9:
            return `${config.podcastPath}${blogPic}`;
        default:
            return `${config.blogPath}${blogPic}`;
    }
}


const Blog = (props) => {
    
    const { viewType, title, fullName, publishDate } = props.data;
    let blogPic = props.data.blogPic;

    if (props.data.blogVideo && props.data.blogVideo.trim() !== '') {
        blogPic = props.data.blogVideo;
    }
    if (viewType === 8) {
        blogPic = props.data.blogVideo; 
    }
    
    const blogId = props.data.id;
    const urlSlug = formaturl(title);

    return (
        <>
            <article className="blog-card">
                <div className="blog-side">
                    <div className="image-container">
                        <span></span>
                        <Link to={`${process.env.REACT_APP_BASE_PATH}/${blogId}/${urlSlug}`} >
                            <img src={getImageSrc(viewType, blogPic)} alt={title} />
                        </Link>
                    </div>
                    <div className="blog-card-info">
                        <h4>{title}</h4>
                        <div className="blog-card-footer">
                            {/*<i className="fa fa-user-circle user" aria-hidden="true"></i>*/}
                            {/*<img src="./images/hero-img.jpg" alt="author-image" />*/}
                            {/*<span>{fullName}</span>*/}
                            <i className="fas fa-clock"></i>
                            <p className="blog-time">{publishDate}</p>
                        </div>
                    </div>
                </div>
            </article>
        </>
    );
}

export default Blog;